<template>
    <sa-page-layout :btnNewVisible="btnNewVisible" :btnBackVisible="true" :btnRefreshVisible="true" @refresh="onRefresh"
        :linkback="linkback" :showModalLoading="showModalLoading">
        <template slot="table-body">
            <div style="height: 100%">
                <b-tabs ref="tabsSoggettoEdit" v-model="activeTabIndex" nav-wrapper-class="sa-tab-items"
                    content-class="mt-3" class="sa-tab" style="height: 100%; padding-bottom: 25px" fill
                    @input="onInputTabs">
                    <b-tab id="tbSoggetto" title="Soggetto" active>
                        <div class="sa-tab-scrol">
                            <contabilita-soggetto-view-component ref="cmpContabilitaSoggettoView"
                                :idSoggetto="idSoggetto" @afterLoadData="afterLoadData"
                                @beforeLoadData="beforeLoadData" />
                        </div>
                    </b-tab>

                    <b-tab id="tbAltriIndirizzi" title="Altri indirizzi" :disabled="isTabDisabled">
                        <div class="sa-tab-scrol">
                            <contabilita-soggetto-altri-indirizzi-list-component ref="cmpAltriIndirizziTab"
                                :idSoggetto="idSoggetto" @afterLoadData="afterLoadData"
                                @beforeLoadData="beforeLoadData" />
                        </div>
                    </b-tab>
                    <b-tab id="tbOrdiniAlFornitore" title="Documenti">
                        <div class="sa-tab-scrol">
                            <ContabilitaDocumentiListComponent :tableHideColumn="tableHideColumn"
                                ref="cmpContabilitaDocumentiListComponent" />
                        </div>
                    </b-tab>
                </b-tabs>
            </div>
        </template>
    </sa-page-layout>
</template>

<script>
import ContabilitaSoggettoViewComponent from "../components/ContabilitaSoggettoViewComponent.vue";
import ContabilitaDocumentiListComponent from "../components/ContabilitaDocumentiListComponent.vue";
import ContabilitaSoggettoAltriIndirizziListComponent from "../components/ContabilitaSoggettoAltriIndirizziListComponent.vue";
import SaPageLayout from "../../../template/sa/components/layout/contents/SaPageLayout.vue";

export default {
    components: {
        ContabilitaSoggettoViewComponent,
        ContabilitaSoggettoAltriIndirizziListComponent,
        SaPageLayout,
        ContabilitaDocumentiListComponent
    },
    data() {
        return {
            activeTabIndex: 0,
            isTabDisabled: false,
            btnNewVisible: false,
            showModalLoading: false,
            linkback: "/contabilita/soggetto",
            idSoggetto: null,
            tableHideColumn: ["actions"],
        };
    },
    mounted() {
        let me = this;
        me.idSoggetto = me.$route.params.id;
        me.activeTab("tbSoggetto");
    },
    methods: {
        onInputTabs(index) {
            let activeTab = this.$refs.tabsSoggettoEdit.getTabs()[index];
            this.activeTab(activeTab.id);
        },

        activeTab(idActiveTab) {
            let me = this;
            switch (idActiveTab) {
                case "tbSoggetto":
                    if (me.$refs.cmpContabilitaSoggettoView && me.$refs.cmpContabilitaSoggettoView.init) {
                        me.$refs.cmpContabilitaSoggettoView.init(me.idSoggetto);
                    }
                    break;

                case "tbAltriIndirizzi":
                    if (me.$refs.cmpAltriIndirizziTab && me.$refs.cmpAltriIndirizziTab.loadData) {
                        me.$refs.cmpAltriIndirizziTab.loadData(me.idSoggetto);
                    }
                    break;
                case "tbOrdiniAlFornitore":
                    if (me.$refs.cmpContabilitaDocumentiListComponent) {
                        me.$refs.cmpContabilitaDocumentiListComponent.loadData({ idSoggetto: me.idSoggetto });
                    }
                    break;
            }
            this.$emit("onActiveTab", idActiveTab);
        },
        onRefresh() {
            this.activeTab(this.$refs.tabsSoggettoEdit.getTabs()[this.activeTabIndex].id);
        },
        afterLoadData() {
            let me = this;
            me.showModalLoading = false;
        },
        beforeLoadData() {
            let me = this;
            me.showModalLoading = true;
        },
    },
};
</script>

<style scoped>
.sa-tab-scrol {
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    padding: 5px 10px 35px 10px;
}
</style>
